/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  LibOwnableRichErrors1,
  LibOwnableRichErrors1Interface,
} from "../LibOwnableRichErrors1";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "resultData",
        type: "bytes",
      },
    ],
    name: "MigrateCallFailedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OnlyOwnerError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "TransferOwnerToZeroError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

export class LibOwnableRichErrors1__factory {
  static readonly abi = _abi;
  static createInterface(): LibOwnableRichErrors1Interface {
    return new utils.Interface(_abi) as LibOwnableRichErrors1Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LibOwnableRichErrors1 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LibOwnableRichErrors1;
  }
}
